import { Dimension } from '@/services/dimension/dimension.model'
import { addDimensionUnit, updateDimensionUnit } from '@/services/dimension/dimension.service'
import { Form, Input, Modal } from 'antd'
import { memo, useEffect, useState } from 'react'

interface CreateEditUnitProps {
  trigger: JSX.Element
  dimension: Dimension.Info
  unit?: Dimension.Unit
  onSuccess: Function
}

const CreateEditUnit = memo<CreateEditUnitProps>((props) => {
  const { trigger, dimension, unit, onSuccess } = props
  const isEdit = !!unit
  const [form] = Form.useForm()
  const [isModalVisible, setIsModalVisible] = useState(false)

  const onFinishHandler = async (values) => {
    if (isEdit) {
      await updateDimensionUnit(dimension.id, unit.id, values)
    } else {
      await addDimensionUnit(dimension.id, values)
    }
    setIsModalVisible(false)
    onSuccess?.()
  }

  useEffect(() => {
    if (unit && isModalVisible) {
      setTimeout(() => {
        form.setFieldsValue(unit)
      }, 100);
    }
  }, [isModalVisible])

  return (<>
    <span onClick={() => setIsModalVisible(true)}>{trigger}</span>
    <Modal
      title={isEdit ? 'Edit Unit' : 'Create Unit'}
      open={isModalVisible}
      destroyOnClose={true}
      onOk={() => form.submit()}
      okText={isEdit ? 'Edit' : 'Create'}
      onCancel={() => setIsModalVisible(false)}
    >
      <Form form={form} preserve={false} onFinish={onFinishHandler} labelCol={{ span: 4 }}>
        <Form.Item name='code' label='Code'>
          <Input type='text' />
        </Form.Item>
        <Form.Item name='description' label='Description'>
          <Input type='text' />
        </Form.Item>
        <Form.Item name='factor' label='Factor'>
          <Input type='number' />
        </Form.Item>
        <Form.Item name='offset' label='Offset'>
          <Input type='number' />
        </Form.Item>
      </Form>
    </Modal>
  </>);
})

export default CreateEditUnit
